module.exports = __webpack_public_path__ + "img/75744.2bb5dc37.svg";